import { CourseStatus } from '@business/entities/course';
import { CourseInboxStatus } from '@business/entities/course_inbox';
import { Styles } from '@core/utils/css';

export function getAllFontWeight() {
  // list of all font weights from 100 to 100 with their labels
  return [
    { label: 'Thin', value: '100' },
    { label: 'Extra Light', value: '200' },
    { label: 'Light', value: '300' },
    { label: 'Normal', value: '400' },
    { label: 'Medium', value: '500' },
    { label: 'Semi Bold', value: '600' },
    { label: 'Bold', value: '700' },
    { label: 'Extra Bold', value: '800' },
    { label: 'Black', value: '900' },
  ];
}

export function getDummyFlowChartData() {
  return [
    {
      $connection: [
        ['u1681930919905', 'u1681930919853'],
        ['u1681930926729', 'u1681930919806'],
      ],
      $item: { editableProperty: { key: null, editableId: null }, config: Object, id: 'u1681930918828' },
      $typeConfig: { type: 'default', lineConfig: Object },
      editable: true,
      extraLinesStroke: '#B8C6D6',
      fill: '#EEF1F6',
      fixed: false,
      fontColor: '#4C4C4C',
      fontSize: 14,
      fontStyle: 'normal',
      height: 75,
      id: 'u1681930918828',
      lineHeight: 14,
      preview: undefined,
      stroke: '#B8C6D6',
      strokeDash: '0',
      strokeType: 'line',
      strokeWidth: 1,
      text: 'Admin',
      textAlign: 'center',
      textVerticalAlign: 'center',
      type: 'rectangle',
      width: 87,
      x: 333,
      y: -40,
    },
    {
      editable: true,
      extralinesstroke: '#B8C6D6',
      fill: '#EEF1F6',
      fixed: false,
      fontcolor: '#4C4C4C',
      fontsize: 14,
      fontstyle: 'normal',
      height: 90,
      id: 'u1681930919806',
      lineheight: 14,
      stroke: '#B8C6D6',
      strokedash: '0',
      stroketype: 'line',
      strokewidth: 1,
      text: 'Manager',
      textalign: 'center',
      textverticalalign: 'center',
      type: 'rectangle',
      width: 140,
      x: 100,
      y: 130,
    },
    {
      editable: true,
      extralinesstroke: '#B8C6D6',
      fill: '#EEF1F6',
      fixed: false,
      fontcolor: '#4C4C4C',
      fontsize: 14,
      fontstyle: 'normal',
      height: 90,
      id: 'u1681930919853',
      lineheight: 14,
      stroke: '#B8C6D6',
      strokedash: '0',
      stroketype: 'line',
      strokewidth: 1,
      text: 'Manager',
      textalign: 'center',
      textverticalalign: 'center',
      type: 'rectangle',
      width: 140,
      x: 450,
      y: 120,
    },
    {
      connecttype: 'elbow',
      cornersRadius: 0,
      customGap: 0,
      forwardArrow: 'filled',
      from: 'u1681930918828',
      fromSide: 'bottom',
      height: 85,
      id: 'u1681930919905',
      points: [
        { x: 376.5, y: 35 },
        { x: 376.5, y: 45 },
        { x: 376.5, y: 110 },
        { x: 520, y: 110 },
        { x: 520, y: 120 },
      ],
      stroke: '#2196F3',
      strokeWidth: 2,
      title: {
        draggable: true,
        editable: true,
        fill: '#FFF',
        fontColor: '#4C4C4C',
        fontSize: 14,
        fontStyle: 'normal',
        fontWeight: 'normal',
      },
      to: 'u1681930919853',
      toSide: 'top',
      type: 'line',
      line: 22,
      width: 143.5,
      x: 376.5,
      y: 35,
    },
    {
      connecttype: 'elbow',
      cornersRadius: 0,
      customGap: 0,
      forwardArrow: 'filled',
      from: 'u1681930918828',
      fromSide: 'bottom',
      height: 140,
      id: 'u1681930926729',
      points: [
        { x: 376.5, y: 35 },
        { x: 376.5, y: 45 },
        { x: 376.5, y: 175 },
        { x: 250, y: 175 },
        { x: 240, y: 175 },
      ],
      stroke: '#2196F3',
      strokeWidth: 2,
      title: {
        draggable: true,
        editable: true,
        fill: '#FFF',
        fontColor: '#4C4C4C',
        fontSize: 14,
        fontStyle: 'normal',
        fontWeight: 'normal',
      },
      to: 'u1681930919853',
      toSide: 'right',
      type: 'line',
      width: 136.5,
      x: 376.5,
      y: 35,
    },
  ];
}

export function getDummyOrgChartData() {
  return [
    {
      $baseHeight: 130,
      $connection: [
        ['u1681930930560', 'u1681930930559'],
        ['u1681930930620', 'u1681930930619'],
      ],
      $count: 2,
      $expandColor: '#607D8B',
      $height: 130,
      $Item: { editableProperty: { key: null, editableId: null }, config: Object, id: '1' },
      $level: 0,
      $parent: undefined,
      $width: 460,
      dx: 410,
      dy: 0,
      editable: true,
      fixed: false,
      headercolor: '#FF9800',
      height: 90,
      id: '1',
      open: true,
      parent: undefined,
      stroke: '#FF9800',
      text: 'Chairman & CEO',
      title: 'John Doe',
      type: 'img-card',
      width: 210,
      x: 130,
      y: 0,
    },
    {
      $baseHeight: 130,
      $connection: undefined,
      $height: 130,
      $Item: { editableProperty: { key: null, editableId: null }, config: Object, id: 'u1681930930559' },
      $level: 1,
      $parent: 'u1681930930560',
      $width: 210,
      dx: 250,
      dy: 0,
      editable: true,
      fixed: false,
      headercolor: '#607D8B',
      height: 90,
      id: 'u1681930930559',
      open: true,
      parent: '1',
      stroke: '#607D8B',
      text: 'John Doe',
      title: 'MANAGER',
      type: 'img-card',
      width: 210,
      x: 0,
      y: 130,
    },
    {
      $item: { editableProperty: { key: null, editableId: null }, config: Object, id: 'u1681930930560' },
      connecttype: 'elbow',
      cornersradius: 0,
      from: '1',
      headercolor: undefined,
      height: 40,
      id: 'u1681930930560',
      points: [
        { x: 645, y: 90 },
        { x: 645, y: 110 },
        { x: 355, y: 110 },
        { x: 355, y: 130 },
      ],
      stroke: '#CCC',
      strokewidth: 2,
      title: {
        draggable: true,
        editable: true,
      },
      to: 'u1681930930559',
      type: 'line',
      width: 290,
      x: 645,
      y: 90,
    },
    {
      $baseHeight: 130,
      $connection: undefined,
      $height: 130,
      $item: { editableProperty: { key: null, editableId: null }, config: Object, id: 'u1681930930619' },
      $level: 1,
      $parent: 'u1681930930620',
      $width: 210,
      dx: 410,
      dy: 0,
      editable: true,
      fixed: false,
      headercolor: '#607D8B',
      height: 90,
      id: 'u1681930930619',
      parent: '1',
      stroke: '#607D8B',
      text: 'John Doe',
      title: 'MANAGER',
      type: 'img-card',
      width: 210,
      x: 250,
      y: 130,
    },
    {
      $item: { editableProperty: { key: null, editableId: null }, config: Object, id: 'u1681930930620' },
      connecttype: 'elbow',
      cornersradius: 0,
      from: '1',
      headercolor: undefined,
      height: 40,
      id: 'u1681930930620',
      points: [
        { x: 645, y: 90 },
        { x: 645, y: 110 },
        { x: 765, y: 110 },
        { x: 765, y: 130 },
      ],
      stroke: '#CCC',
      strokewidth: 2,
      to: 'u1681930930619',
      type: 'line',
      width: 120,
      x: 645,
      y: 90,
    },
  ];
}

export function getGalleryDummyImages() {
  return [
    Styles.assets('images/course/gallery/gallery1.jpeg'),
    Styles.assets('images/course/gallery/gallery2.jpeg'),
    Styles.assets('images/course/gallery/gallery3.jpeg'),
    Styles.assets('images/course/gallery/gallery4.jpeg'),
  ];
}

export function getStatusTitle(status: CourseStatus) {
  switch (status) {
    case CourseStatus.all:
      return 'All';
    case CourseStatus.publish:
      return 'Published';
    case CourseStatus.unpublish:
      return 'Unpublished';
  }
}

export function getStatusLabel(status: CourseInboxStatus) {
  switch (status) {
    case CourseInboxStatus.open:
      return 'Respond';
    case CourseInboxStatus.replied:
      return 'Respond and Reject';
    case CourseInboxStatus.closed:
      return 'Respond and Approve';
  }
}
